<div class="main-padding">
  <h3 class="header-bottom header-text1">
    {{ 'REGISTRANT_LIST.TITLE' | translate }}
  </h3>
  <div class="card-body search-form-top">
     <!-- Input -->
     <div class="row">
      <div class="input-group company-name">
        <input
          type="text"
          class="form-control"
          id="CompanyName"
          [(ngModel)]="CompanyName"
          placeholder="{{
            'REGISTRANT_LIST.COMPANY_NAME_PLACEHOLDER' | translate
          }}"
        />
        <img *ngIf="!CompanyName" class="icon" src="assets/icons/book.svg" />
      </div>
      <div class="input-group acquired-company" *ngIf = "User_Auth != 'wf-fc-head'">
        <input 
          list="brow" 
          class="form-control" 
          [(ngModel)]="acquired_data" 
          placeholder="{{
            'REGISTRANT_LIST.ACQUIRED_COMPANY_NAME_PLACEHOLDER' | translate
          }}">
        <datalist id="brow" required name="acquired_data">
          <option class="acquired-font" *ngFor="let i of AcquiredInfo" 
            value="{{i.acquired_code}}:{{ i.acquired_name }}">
          </option>
        </datalist>
        <img  *ngIf="!acquired_data" id="book" class="icon" src="assets/icons/openbookblack.svg"/>
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="input-group family-name">
        <input
          type="text"
          class="form-control"
          id="name"
          [(ngModel)]="FamilyName"
          placeholder="{{ 
            'REGISTRANT_LIST.FAMILY_NAME_PLACEHOLDER' | translate 
          }}"
        />
        <img *ngIf="!FamilyName" class="icon" src="assets/icons/user-icon.svg" />
      </div>
      <div class="input-group telephone">
        <input
          type="text"
          class="form-control"
          id="Number"
          name="Number"
          [(ngModel)]="Number"
          placeholder="{{
            'REGISTRANT_LIST.PERSONAL_NUMBER_PLACEHOLDER' | translate
          }}"
          maxlength="11"
          onkeypress="return (event.charCode != 69 && event.charCode != 101) && (event.charCode < 42 && 8 <= event.charCode) || (event.charCode <= 57 && 47 < event.charCode)"
        />
        <img *ngIf="!Number" class="icon" src="assets/icons/number.svg" />
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="input-group telephone">
        <input
          type="text"
          class="form-control"
          id="casioId"
          name="casioId"
          [(ngModel)]="casioId"
          placeholder="{{
            'REGISTRANT_LIST.CASIO_ID_PLACEHOLDER' | translate
          }}"
        />
        <img *ngIf="!Number" class="icon" src="assets/icons/number.svg" />
      </div>
    </div>
    <!-- Check -->
    <div class="row checkbox-top">
      <label  class="ftext des">{{
        'REGISTRANT_LIST.CHECKBOX_TEXT' | translate
      }}</label>
      <!-- Check 1 -->
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline "
              type="checkbox"
              id="customCheckbox1"
              [(ngModel)]="customCheckbox1"
            />
            <label for="customCheckbox1" class="custom-control-label ftext ml">{{'REGISTRANT_LIST.STATUS_1' | translate}}</label>
          </div>
        </div>
      </div>
      <!-- Check 2 -->
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline "
              type="checkbox"
              id="customCheckbox2"
              [(ngModel)]="customCheckbox2"
            />
            <label for="customCheckbox2" class="custom-control-label ftext ml">{{
              'REGISTRANT_LIST.STATUS_2' | translate
            }}</label>
          </div>
        </div>
      </div>
      <!-- Check 3 -->
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline "
              type="checkbox"
              id="customCheckbox3"
              [(ngModel)]="customCheckbox3"
            />
            <label for="customCheckbox3" class="custom-control-label ftext ml">{{
              'REGISTRANT_LIST.STATUS_3' | translate
            }}</label>
          </div>
        </div>
      </div>
      <!-- Check 4 -->
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline "
              type="checkbox"
              id="customCheckbox4"
              [(ngModel)]="customCheckbox4"
            />
            <label for="customCheckbox4" class="custom-control-label ftext ml">{{
              'REGISTRANT_LIST.STATUS_4' | translate
            }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-search-top">
      <a target="_blank" class="btn-search" (click)="Search()"
        >{{ 'CONTRACT_APP_LIST.SEARCH_BUTTON' | translate }}
        <img
          class="search-icon"
          src="assets/icons/srch.svg"
        />
      </a>
    </div>
    <!-- Radio -->
    <div class="row select-radio-top">
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-radio">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline"
              type="radio"
              checked
              id="r1"
              name="customRadio" (click)="selectedRadios(10)"
            />
            <label for="r1" class="custom-control-label ftext">{{
              'COMMON.CASE_10' | translate
            }}</label>
          </div>
        </div>
      </div>
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-radio">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline"
              type="radio"
              id="r2"
              name="customRadio" (click)="selectedRadios(20)"
            />
            <label for="r2" class="custom-control-label ftext">{{
              'COMMON.CASE_20' | translate
            }}</label>
          </div>
        </div>
      </div>
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-radio">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline"
              type="radio"
              id="r3"
              name="customRadio" (click)="selectedRadios(50)"
            />
            <label for="r3" class="custom-control-label ftext">{{
              'COMMON.CASE_50' | translate
            }}</label>
          </div>
        </div>
      </div>
      <div class="column-check">
        <div class="form-group">
          <div class="custom-control custom-radio">
            <input
              class="custom-control-input custom-control-input-danger custom-control-input-outline"
              type="radio"
              id="r4"
              name="customRadio" (click)="selectedRadios(100)"
            />
            <label for="r4" class="custom-control-label ftext">{{
              'COMMON.CASE_100' | translate
            }}</label>
          </div>
        </div>
      </div>
    </div>
    <section class="content">
      <div class="container-fluid">
        <div class="row table-width">
          <table class="table table-bordered" style="min-width: 1000px;">
            <thead>
              <tr class="text-center">
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.CORPORATE_NUMBER_COLUMN' | translate
                  }}
                </th>
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.COMPANY_NAME_COLUMN' | translate
                  }}
                </th>
                <th class="ftext" *ngIf = "User_Auth != 'wf-fc-head'" >
                  {{
                    'REGISTRANT_LIST.ACQUIRED_COMPANY_NAME_COLUMN' | translate
                  }}
                </th>
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.FAMILY_NAME_COLUMN' | translate
                  }}
                </th>
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.MEMBERSHIP_NUMBER_COLUMN' | translate
                  }}
                </th>
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.PERSONAL_NUMBER_COLUMN' | translate
                  }}
                </th>
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.USAGE_SITUATION_COLUMN' | translate
                  }}
                </th>
                <!-- <th class="ftext" style="padding-left: 16px; padding-right: 16px;">
                  {{
                    'REGISTRANT_LIST.USAGE_SITUATION_COLUMN' | translate
                  }}
                </th> -->
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.CONTRACT_DATE_COLUMN' | translate
                  }}
                  <a><i (click)="order(1)" class="icon-arrow-up"></i></a>
                  <a><i (click)="order(2)" class="icon-arrow-down"></i></a>
                </th>
                <th class="ftext">
                  {{
                    'REGISTRANT_LIST.WITHDRAWAL_DATE_COLUMN' | translate
                  }}
                  <a><i (click)="order(3)" class="icon-arrow-up"></i></a>
                  <a><i (click)="order(4)" class="icon-arrow-down"></i></a>
                </th>
                <th class="ftext" style="padding-left: 16px; padding-right: 16px;">
                  {{
                    'REGISTRANT_LIST.NUMBER_OF_TIMES_OF_USE_COLUMN' | translate
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let list of items" class="text-center">
                <td class="tbtext tdata1">{{ list.corporation_no }}</td>
                <td class="tbtext tdata2">{{ list.company_name }}</td>
                <td class="tbtext tdata2" *ngIf = "User_Auth != 'wf-fc-head'" >{{ list.acquired_name }}</td>
                <td class="tbtext tdata2">{{ list.name }}</td>
                <td class="tbtext tdata3">{{ list.casio_id }}</td>
                <td class="tbtext tdata3">{{ list.user_no }}</td>
                <td class="tbtext tdata2" *ngIf="list.use_status == '1'">
                  {{'REGISTRANT_LIST.STATUS_1' | translate}}
                </td>
                <td class="tbtext tdata2" *ngIf="list.use_status == '2'">
                  {{'REGISTRANT_LIST.STATUS_2' | translate}}
                </td>
                <td class="tbtext tdata2" *ngIf="list.use_status == '3'">
                  {{'REGISTRANT_LIST.STATUS_3' | translate}}
                </td>
                <td class="tbtext tdata2" *ngIf="list.use_status == '4'">
                  {{'REGISTRANT_LIST.STATUS_4' | translate}}
                </td>
                <td
                class="tbtext tdata-4"*ngIf="list.use_status == '  '" ></td>
                <td class="tbtext tdata6">{{ list.app_start }}</td>
                <td class="tbtext tdata6">{{ list.app_end }}</td>
                <td class="tbtext tdata9">{{ list.use_count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="filteredItems.length >= 1">
          <label class="pages">{{'COMMON.PAGE' | translate}} {{ currentIndex }}/{{ pageNumber }}</label>
        </div>
        <div class="page-point" *ngIf="filteredItems.length >= 1">
          <span
            [ngClass]="{ disabled: currentIndex == 1 || pageNumber == 0 }"
            (click)="prevPage()"
            class="prev"
            >&laquo;
          </span>
          <span
            *ngFor="let page of pagesIndex"
            [ngClass]="{ tod: currentIndex == page }"
            class="dot"
            (click)="setPage(page)"
          ></span>
          <span
            [ngClass]="{ disabled: currentIndex == pageNumber || pageNumber == 0 }"
            (click)="nextPage()"
            class="next"
            >&raquo;
          </span>
        </div>
        <div class="text-center" style="margin-top: 16px;max-width: 1500px;">
          <div class="col-12">
            <div class="display">
              <a (click)="csvOutput()" class="btn-search csv-font">
                {{'COMMON.CSV' | translate}}
              </a>
              <i class="fa fa-print"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#E10800 " type = "square-jelly-box" [fullScreen] = "true">
  <p style="color: #E10800 " > {{ 'COMMON.LOADING' | translate }} </p>>
</ngx-spinner>